<template>
  <AppModal shown>
    <CreditCardRegistrationView />
  </AppModal>
</template>

<script setup lang="ts">
import CreditCardRegistrationView from './CreditCardRegistrationView.vue'
import AppModal from '@/components/atoms/AppModal.vue'

import { tryOnUnmounted, useScrollLock } from '@vueuse/core'

const bodyEl = document.querySelector('body')
const lock = useScrollLock(bodyEl, true)

tryOnUnmounted(() => {
  lock.value = false
})
</script>
